<template>
    <div>
        <statistics-filter-component v-model="filters" :display_chart="display_chart" @display_mode="displayChart" @search="fetchStatistics"/>
        <div v-if="total">
            <div v-if="stat_compared.length > 0">
                <div v-if="filters.date">
                    <font-awesome-icon icon="square" :class="{white: !display_chart, chart1: display_chart}" class="border"/>
                        vom {{filters.date.from | date}} bis {{filters.date.to | date}}
                </div>
                <div v-if="filters.period && filters.period.type != '' && filters.period.type != 'date_picker' && date_ranges">
                    <font-awesome-icon icon="square" :class="{white: !display_chart, chart1: display_chart}" class="border"/>
                    <!-- {{$t('intern_statistics.' + filters.period.type)}} -->
                    vom {{date_ranges.start}} bis {{date_ranges.end}}
                </div>
                <div v-if="filters.dateCompare">
                    <font-awesome-icon icon="square" class="compare" :class="{chart2: display_chart}"/>
                        vom {{filters.dateCompare.from | date}} bis {{filters.dateCompare.to | date}}
                </div>
                <div v-if="filters.period && filters.period.type_compare != '' && filters.period.type_compare != 'date_picker'">
                    <font-awesome-icon icon="square" class="compare" :class="{chart2: display_chart}"/>
                    <!-- {{$t('intern_statistics.' + filters.period.type_compare)}} -->
                    vom {{date_ranges.start_compare}} bis {{date_ranges.end_compare}}
                </div>
            </div>
            <div v-if="!display_chart">
                <statistics-list-component
                    :statistics="statistics"
                    :stat_compared="stat_compared"
                    :total="total"
                    :total_compared="total_compared"
                    :has_deeplink="has_deeplink"
                    @sort="sortList"
                />
                <div class="row">
                    <div class="col-12 col-md-9">
                        <pagination-component :page="page" routePath="inserat-statistik" :numOfPages="numOfPages"/>
                    </div>
                    <div class="col-12 col-md-3" v-if="!isMobile">
                        <select class="form-control" v-model="limit">
                            <option value="10">10 Inserate / Seite</option>
                            <option value="25">25 Inserate / Seite</option>
                            <option value="50">50 Inserate / Seite</option>
                            <option value="100">100 Inserate / Seite</option>
                        </select>
                    </div>
                </div>
            </div>
            <div v-else>
                <chart-component :filters="filters" :date_ranges="date_ranges"/>
            </div>
        </div>
        <div v-else>
            <div class="alert alert-warning">
                Kein Ergebnis
            </div>
        </div>
    </div>
</template>

<script>
    import StatisticsFilterComponent from '../../components/statistics/StatisticFilter';
    import StatisticsListComponent   from '../../components/statistics/StatisticList';
    import ChartComponent            from '../../components/statistics/Chart';
    import PaginationComponent       from '../../components/shared/Pagination';
    import { IsMobileMixin }         from '../../mixins/IsMobile';

    export default {
        name: 'inserat-statistik',
        data() {
            return {
                filters:        {},
                total:          null,
                statistics:     [],
                total_compared: null,
                stat_compared:  [],
                numOfPages:     0,
                sort:           'id',
                order:          'desc',
                display_chart:  false,
                limit:          10,
                request_sent:   false,
                date_ranges:    null,
                has_deeplink:   false
            }
        },
        props: ['page'],
        mixins: [ IsMobileMixin ],
        watch: {
            filters(val) {
                this.$router.replace({ name: 'inserat-statistik', params: {page: 1}});
                if(!this.display_chart){
                    this.fetchStatistics();
                }
            },
            page(val) {
                this.fetchStatistics();
            },
            limit(newVal, oldVal) {
                if(newVal != oldVal) {
                    if(this.page != 1){
                        this.$router.replace({ name: 'inserat-statistik', params: {page: 1}});
                        this.page = 1;
                    }
                    this.fetchStatistics();
                }
            }
        },
        components: {
            StatisticsFilterComponent,
            StatisticsListComponent,
            ChartComponent,
            PaginationComponent
        },
        methods: {
            fetchStatistics() {
                if(!this.request_sent){
                    this.request_sent = true;
                    this.$store.state.loading = true;
                    this.$http.get('/statisticsApi/getStatistics', {
                        params: {
                            filters: this.filters,
                            page: this.page,
                            sort: this.sort,
                            order: this.order,
                            limit: this.limit
                        }
                    }).then(response => {
                        let data            = JSON.parse(response.data);
                        this.total          = data.total          ? data.total          : null;
                        this.total_compared = data.total_compared ? data.total_compared : null;
                        this.statistics     = data.statistics     ? data.statistics     : [];
                        this.stat_compared  = data.stat_compared  ? data.stat_compared  : [];
                        this.date_ranges    = data.dates ? data.dates : null;
                        this.has_deeplink   = data.has_deeplink ? true : false;

                        if(this.total) {
                            this.numOfPages = Math.ceil(this.total.object_count / this.limit);
                        }
                    }).catch(error => {
                        console.log(error);
                    }).then(() => {
                        this.$store.state.loading = false;
                        this.request_sent         = false;
                    });
                }
            },
            sortList(sort) {
                if(this.sort == sort){
                    if(this.order == 'desc'){
                        this.order = 'asc';
                    }else {
                        this.order = 'desc';
                    }
                }else {
                    this.order = 'desc';
                }

                this.sort = sort;
                this.fetchStatistics();
            },
            displayChart(val) {
                this.display_chart = val;
            }
        },
        created() {
            document.title = 'Meine Statistik';
            if(!this.page) {
                this.$router.replace({ name: 'inserat-statistik', params: {page: 1}});
            }
            this.fetchStatistics();
        },
    }
</script>

<style scoped>
.white{
    color: white !important;
}
.chart1{
    color: #3366cc;
    border: none !important;
}
.chart2{
    color: #dc3912 !important;
}
.compare{
    color: #ebebeb;
}
</style>
